import React from 'react'
import {useSelector} from 'react-redux'
import {useTranslation} from 'react-i18next'

import './index.less'
import './mobile.less'
import noImage from '@/assets/img/icon/noImage.png'

const defaultProps = {
  img: noImage,
  name: '',
  description: '',
  onCategoryItemClick: () => {},
  productType: null,
  quantity: 0,
}
export default function CategoryItem(props) {
  const options = Object.assign({}, defaultProps, props);
  const commonState = useSelector(state => state.common)
  const rootClassName = commonState.isMobile ? 'cat-item-mobile-container' : 'cat-item-container'

  const handleCategoryItemClick = () => {
    options.onCategoryItemClick()
  }

  return (
    <div className={rootClassName} onClick={handleCategoryItemClick}>
      <div className={'cat-item-img-container'}>
        {options.img ? <img src={options.img} alt=""/> : <img src={noImage} alt=""/>}
      </div>
      <div className={'cat-item-name'}>
        <span>{options.name}</span>
      </div>
      <div className={'cat-item-des'}>
        <span>{options.description}</span>
      </div>
    </div>
  )
}
